import axios from '../axiosHelper';
import Cookies from "js-cookie"

export default {
    state: {
        status: '',
        status_code: '',
        message: '',
        message_code: '',
        appraisalOverview : {},
        studentAppraisalList : [],
        taList : [],
        appraisalType : [{}],
    },
    getters: {
        getAppraisalOverview: state => state.appraisalOverview,
        getAppraisalType: state => state.appraisalType,
        getStudentAppraisalList: state => state.studentAppraisalList,
        getTaList: state => state.taList,
    },
    mutations: {
        request(state){
            state.status = 'LOADING'
        },
        success(state, { resp }){
            state.status = 'SUCCESS'
            if (resp) {
                state.status_code = resp.data.status
                state.message = resp.data.message
                state.message_code = resp.data.code
            }
        },
        error(state, { resp }){
            state.status = 'ERROR'
            if (resp) {
                state.status_code = resp.data.status
                state.message = resp.data.message
                state.message_code = resp.data.code
            }
        },
        setTaskOverView(state, { resp }){
            if (resp) {
                state.appraisalOverview = resp.data.data
            }
        },
        setStudentAppraisalList(state, { resp }){
            if (resp) {
                state.studentAppraisalList = resp.data.data
            }
        },
        setTaList(state, { resp }){
            if (resp) {
                state.taList = resp.data.data
            }
        },
        setAppraisalType(state, { resp }){
            if (resp) {
                state.appraisalType = resp.data.data
            }
        }
    },
    actions: {
        getAppraisalOverview({commit}, param){
            return new Promise(function (resolve, reject) {
                commit('request');
                axios({
                        url: '/v1/quiz/get-overview/'+param.modulId+'?token='+Cookies.get("token"),
                        method: 'GET'
                    })
                    .then(resp => {
                        commit('success', { resp })
                        commit('setTaskOverView', { resp })
                        resolve(resp)
                    })
                    .catch(err => {
                        let resp = err.response
                        commit('error', { resp })
                        reject(err)
                    })
            })
        },
        getAppraisalType({commit}){
            return new Promise(function (resolve, reject) {
                commit('request');
                axios({
                        url: '/v1/quiz/get-type?token='+Cookies.get("token"),
                        method: 'GET'
                    })
                    .then(resp => {
                        commit('success', { resp })
                        commit('setAppraisalType', { resp })
                        resolve(resp)
                    })
                    .catch(err => {
                        let resp = err.response
                        commit('error', { resp })
                        reject(err)
                    })
            })
        },
        getStudentAppraisalList({commit}, param){
            return new Promise(function (resolve, reject) {
                commit('request');
                axios({
                        url: '/v1/quiz/get-assessment-list/'+param.appraisalId+'/'+param.taId+'?token='+Cookies.get("token"),
                        method: 'GET'
                    })
                    .then(resp => {
                        commit('success', { resp })
                        commit('setStudentAppraisalList', { resp })
                        resolve(resp)
                    })
                    .catch(err => {
                        let resp = err.response
                        commit('error', { resp })
                        reject(err)
                    })
            })
        },
        getTaList({commit}){
            return new Promise(function (resolve, reject) {
                commit('request');
                axios({
                        url: '/v2/tahun-ajaran/get-list?token='+Cookies.get("token"),
                        method: 'GET'
                    })
                    .then(resp => {
                        commit('success', { resp })
                        commit('setTaList', { resp })
                        resolve(resp)
                    })
                    .catch(err => {
                        let resp = err.response
                        commit('error', { resp })
                        reject(err)
                    })
            })
        },
        resetAppraisal({commit}, form){
            return new Promise(function (resolve, reject) {
                commit('request');
                axios({
                        url: '/v1/quiz/reset-assessment?token='+Cookies.get("token"),
                        data: form,
                        method: 'POST'
                    })
                    .then(resp => {
                        commit('success', { resp })
                        resolve(resp)
                    })
                    .catch(err => {
                        let resp = err.response
                        commit('error', { resp })
                        reject(err)
                    })
            })
        },
        addAppraisal({commit}, form){
            return new Promise(function (resolve, reject) {
                commit('request');
                axios({
                        url: '/v1/quiz/add?token='+Cookies.get("token"),
                        data: form,
                        method: 'POST'
                    })
                    .then(resp => {
                        commit('success', { resp })
                        resolve(resp)
                    })
                    .catch(err => {
                        let resp = err.response
                        commit('error', { resp })
                        reject(err)
                    })
            })
        },
        updateAppraisal({commit}, form){
            return new Promise(function (resolve, reject) {
                commit('request');
                axios({
                        url: '/v1/quiz/edit?token='+Cookies.get("token"),
                        data: form,
                        method: 'POST'
                    })
                    .then(resp => {
                        commit('success', { resp })
                        resolve(resp)
                    })
                    .catch(err => {
                        let resp = err.response
                        commit('error', { resp })
                        reject(err)
                    })
            })
        },
        deleteAppraisal({commit}, form){
            return new Promise(function (resolve, reject) {
                commit('request');
                axios({
                        url: '/v1/quiz/delete?token='+Cookies.get("token"),
                        data: form,
                        method: 'POST'
                    })
                    .then(resp => {
                        commit('success', { resp })
                        resolve(resp)
                    })
                    .catch(err => {
                        let resp = err.response
                        commit('error', { resp })
                        reject(err)
                    })
            })
        },
    }
}
